import { useQuery } from '@tanstack/react-query'

import { getFeatureFlag } from '@/global/plugins/firebase'
import { FeatureFlagConstant } from '@/global/types'
import { FeatureFlag } from '@/global/plugins/firebase/types'
import { useAddError } from '../useError'
import { makeFeatureFlagKey } from '@/global/utils/react-query-keys'
import {
  Context,
  FeatureFlagCode
} from '@/global/plugins/observability/observability.constants'
import { resolveFeatureFlagValue } from './useGetFeatureFlag.helpers'
import { UseGetFeatureFlagPropsResult } from './useGetFeatureFlag.types'

const useGetFeatureFlag = ({
  namespace,
  key
}: FeatureFlagConstant): UseGetFeatureFlagPropsResult => {
  const { data, error, isPending } = useQuery<FeatureFlag, Error>({
    queryKey: makeFeatureFlagKey({ namespace, key }),
    queryFn: () => getFeatureFlag({ namespace, key }),
    retry: false
  })

  useAddError({
    error,
    data: {
      context: Context.FEATURE_FLAG,
      code: FeatureFlagCode.GET_FEATURE_FLAG_ERROR,
      message: `Erro ao obter feature flag: ${namespace}-${key}`
    }
  })

  return {
    value: resolveFeatureFlagValue(data),
    isLoading: isPending
  }
}

export { useGetFeatureFlag }
